import React from 'react'
import { useSelector } from 'react-redux'

import DashboardSingleListNoteContainer from './single-note-container'
import DashboardSingleListNoNotesContainer from './no-notes-container'
import DashboardSingleListComposeNoteContainer from './compose-note-container'
import { TableLoader } from '../../../../../library/table-loader'

const Index = () => {

	const allNotes = useSelector(state => state.singleList.notes)
	const loading = useSelector(state => state.singleList.fetchSingleNotes.loading)
	/*
	const dispatch = useDispatch()
	const company = useSelector(state => state.singleList.activeDisplay)
	const allNotes = [];

	useEffect(() => {
		if(company.name !== null){
			
		}
	}, [company])*/

	return(
		<div className="tab-pane all-details-list-tab fade show" id="nav-notes" role="tabpanel" aria-labelledby="nav-notes-tab">
			<div className="tab-content-container">
				<div className="all-written-notes-container">
					{!loading && allNotes && allNotes.length > 0 && 
						allNotes.map((singleNote, index, arr) => {
							return(
								<DashboardSingleListNoteContainer singleNote={singleNote} index={index} arr={arr} />
							)
						})
					}
					{!loading && allNotes && allNotes.length === 0 && <DashboardSingleListNoNotesContainer/>}
					{loading && <TableLoader/>}
				</div>
				<DashboardSingleListComposeNoteContainer/>
			</div>
		</div>
	)
}

export default Index